export default {
  GET_VISIT_TYPES: {
    MOBILE: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description:
          'Sorry, there was an issue fetching the list of visit types. Pull down to refresh and try again.'
      }
    },
    WEB: {
      ERROR: {
        severity: 'error' as 'error',
        title: 'Uh oh!',
        description: 'Sorry, there was an issue fetching the list of visit types.'
      }
    },
    NO_DATA: {
      message:
        'This provider does not have availability online at this time, please call the clinic for an appointment.'
    },
    NO_SLOTS_AVAILABLE: {
      message:
        'There is a problem with scheduling with this provider online. Please call the clinic to get the care you need.'
    },
    SERVICE_DOWN: {
      message: 'There is a problem with online scheduling at this time. Please try again later.'
    }
  }
};
